import React, { useRef,useEffect,useState,memo } from "react";
import Typography from "@material-ui/core/Typography";
import {
  Avatar,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Collapse,
  CardContent,
} from "@material-ui/core";
import {
  ArrowDropDown,
  ArrowDropUp,
  Bookmark,
  ChatBubble,
  MoreVert,
  Share,
} from "@material-ui/icons";
import Popover from "@material-ui/core/Popover";
import { Alert } from "@material-ui/lab";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { FaClipboard, FaFacebook, FaFacebookSquare, FaLinkedin, FaTwitterSquare, FaWhatsappSquare } from "react-icons/fa";
import {MdContentCopy} from 'react-icons/md'
import { HiOutlineUpload } from "react-icons/hi";
import { useSelector,useDispatch } from "react-redux";
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import { setAllContent, setFilteredContent, addProfile } from "../../../redux/actions";

const QuesCard = memo(React.forwardRef(({ data },lastContentElementRef) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [open, setOpen] = useState(false);
  const id = open ? "simple-popover" : undefined;
  const reduxState = useSelector(state => state)
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(reduxState.allContent.contentBySlug);
  const [answer, setAnswer] = useState("");
  const answerInputRef = useRef(null);
  const descRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    const parser = new DOMParser();
    let doc = parser.parseFromString(data.desc,'text/html');
    descRef.current.innerHTML = doc.body.innerHTML;
  },[])
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleSnack = () => {
    setOpen(true);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick2 = (event) => {
    if(!reduxState.authUser.isAuthenticated){
      return Swal.fire({
        icon:'info',
        text:'Please Signup/Login to the platform!',
        timer:2000
      })
    }

    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const copyLinkToClipboard = () => {
    handleSnack();
    const elem = document.createElement('textarea');
    elem.value = `https://recruitingmonk2.azurewebsites.net/qnas/${data._id}`;
    document.body.appendChild(elem);
    elem.select();
    console.log(elem)
    elem.setSelectionRange(0, 99999); /* For mobile devices */

    // Copy the text inside the text field 
    navigator.clipboard.writeText(elem.value);
    document.body.removeChild(elem);

    saveQnaShare("clipboard");
  }

  const token = window.localStorage.getItem('token');
      let axiosConfig = {
        headers: {
          'authorization': token,
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
        }
      }
      
      const updateContent = (response) => {
        let allContent = [].concat(reduxState.allContent.allContent),qnas = [].concat(reduxState.allContent.qnas),filteredContent = [].concat(reduxState.allContent.filteredContent),currentQna = data;
            allContent.splice(allContent.indexOf(currentQna),1,response.qna);
            filteredContent.splice(filteredContent.indexOf(currentQna),1,response.qna);
            qnas.splice(qnas.indexOf(currentQna),1,response.qna);
            dispatch(setAllContent(allContent));
            dispatch(setFilteredContent(filteredContent));
      }

      async function addAnswer(){
        const token = window.localStorage.getItem('token');
        if(!reduxState.authUser.isAuthenticated) {
          return Swal.fire({
            icon: "info",
            title: "Oops..",
            text: "Please SignUp/Login the Platform",
          });
        }
        fetch(`https://recruitingmonk-v2.azurewebsites.net/qna/answer/${data._id}`, {
            method:'POST',
            headers: {
              'Authorization': token,
              'Content-Type': 'application/json'
            },
            body:JSON.stringify({content:answer,uid:reduxState.info.info.uid})
          }).then(res => res.json())
            .then((res) => {
              if(res.success){
                console.log("answered")
                updateContent(res)
              }
            }).catch(err => {
              alert('cannot answer')
              console.log(err)
            })
            answerInputRef.current.value = '';
      }

  const upvote = (action) => {
    const token = window.localStorage.getItem('token');
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }
    fetch(`https://recruitingmonk-v2.azurewebsites.net/qna/upvote/${action}/${data._id}`, {
        method:'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({uid:reduxState.info.info.uid})
      }).then(res => res.json())
        .then((res) => {
          if(res.success){
            console.log("toggled Upvote");
            updateContent(res)
          }
        }).catch(err => {
          alert('cannot vote qna')
          console.log(err)
        });
  }

  const downvote = (action) => {
    const token = window.localStorage.getItem('token');
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }
    fetch(`https://recruitingmonk-v2.azurewebsites.net/qna/downvote/${action}/${data._id}`, {
        method:'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({uid:reduxState.info.info.uid})
      }).then(res => res.json())
        .then((res) => {
          if(res.success){
            console.log("toggled Downvote")
            updateContent(res)
          }
        }).catch(err => {
          alert('cannot vote qna')
          console.log(err)
        });
  }

  const saveMyFeed = () => {
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }

    const token = localStorage.getItem('token');
    fetch(`https://recruitingmonk-v2.azurewebsites.net/savefeed`,{
      headers:{
        'Content-Type':'application/json',
        'Authorization':token,
      },
      method:'POST',
      body:JSON.stringify({
       uid:reduxState.info.info.uid,
       id:data._id,
       title:data.question,
       content:"",
       tag:'qna',
      })
    }).then(response => {
      if(response.ok) {
          console.log(response)
          return response;
      }
      else {
          var error = new Error("Error " + response.status + ": " + response.statusText);
          error.response = response;
          throw error;
      }
  }).then(response => response.json())
  .then(response => {
    if(response.success){
      const updatedFeed = reduxState.info.info.feed;
      updatedFeed.unshift(response.feedItem);
      dispatch(addProfile({feed:updatedFeed}))
      console.log("saved feed updated")
    }
    else throw new Error('unable to save feed')
  }).catch((error) => {
    console.log(error);
  })
  }

  const saveQnaShare = (socialMedia) => {
    const token = localStorage.getItem('token');
    fetch(`https://recruitingmonk-v2.azurewebsites.net/qna/share/${data._id}`,{
      headers:{
        'Content-Type':'application/json',
        'Authorization':token,
      },
      method:'POST',
      body:JSON.stringify({
       uid:reduxState.info.info.uid,
       socialMedia,       
      })
    }).then(response => {
      if(response.ok) {
          console.log(response)
          return response;
      }
      else {
          var error = new Error("Error " + response.status + ": " + response.statusText);
          error.response = response;
          throw error;
      }
  }).then(response => response.json())
  .then(response => {
    if(response.success) console.log("share saved successfully");
  }).catch(console.log)
  }

  return (
    <div ref={lastContentElementRef} className="flex flex-col p-2 md:mx-2 mb-5 rounded-xl bg-white shadow-xl md:bg-transparent md:shadow-none glass">
      <div className="flex flex-col mb-2">
        <div className="flex flex-row gap-2 justify-start items-center">
          <Avatar alt={data.name} src={data.avatar} onClick={() => history.push(`/profile/${data.author}`)} style={{cursor:'pointer'}} />
          <div className="flex-grow">
            <Typography variant="button" component="p" onClick={() => history.push(`/profile/${data.author}`)} style={{cursor:'pointer'}}>
              {data.name}
            </Typography>
            <Typography variant="caption" component="p" color="textSecondary">
              @{data.username.split("@")[0]}
            </Typography>
          </div>
          <IconButton onClick={handleClick}>
            <MoreVert />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            style={{ marginTop: "2.4em" }}
          >
            <MenuItem onClick={copyLinkToClipboard}>Copy Link</MenuItem>
            <MenuItem onClick={handleClose}>Unfollow</MenuItem>
            <MenuItem onClick={handleClose}>Report</MenuItem>
          </Menu>
          <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={handleSnackClose}
          >
            <Alert onClose={handleSnackClose} severity="info">
              Link copied to Clipboard!
            </Alert>
          </Snackbar>
        </div>
      </div>
      <div className="flex flex-row mt-3 px-1">
        <div className="flex flex-col items-center gap-2 mr-2">
          <IconButton onClick={()=> upvote(data.upvotes.find(vote => vote.user === reduxState.info.info.uid)?.user?'remove':'add')}>
            <ArrowDropUp fontSize="large" htmlColor={data.upvotes.find(vote => vote.user === reduxState.info.info.uid)?.user? "#B0343C" : ""} />
          </IconButton>
          <p className="text-lg font-semibold">{data.upvotes.length - data.downvotes.length}</p>
          <IconButton onClick={()=> downvote(data.downvotes.find(vote => vote.user === reduxState.info.info.uid)?.user?'remove':'add')}>
            <ArrowDropDown fontSize="large" htmlColor={data.downvotes.find(vote => vote.user === reduxState.info.info.uid)?.user? "#B0343C" : ""} />
          </IconButton>
        </div>
        <div className="flex flex-col gap-2">
          <div className="">
            <Typography
              variant="h5"
              color="textPrimary"
              style={{ whiteSpace: "pre-line" }}
              component="p"
            >
              {data.question}
            </Typography>
          </div>
          <div className="mb-2">
            <Typography
              variant="body1"
              color="textPrimary"
              style={{ whiteSpace: "pre-wrap" }}
              component="span"
            >
              <div ref={descRef}></div>
            </Typography>
          </div>
        </div>
      </div>
      <Divider />
      <div className="flex flex-row items-center justify-between ">
        <div className="flex flex-row items-center gap-2 mx-2">
          <p onClick={handleExpandClick} className="font-medium text-lg cursor-pointer">
            {" "}
            <ChatBubble htmlColor="#B0343C" /> {data.answers.length}
          </p>
          <IconButton onClick={handleClick2}>
            <Share htmlColor="#B0343C" />
          </IconButton>
          <Popover
            id={id}
            open={Boolean(anchorEl2)}
            anchorEl={anchorEl2}
            onClose={handleClose2}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <div className="p-2 gap-4 text-3xl rounded-full flex flex-row items-center px-2" >
            <FacebookShareButton children={<FaFacebookSquare color="#4267B2" />} quote={`${data.question}`} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} onShareWindowClose={() => saveQnaShare("facebook")} />
              <LinkedinShareButton children={<FaLinkedin color="#0077b5" />} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} title={`${data.question}`} onShareWindowClose={() => saveQnaShare("linkedin")} />
              <WhatsappShareButton children={<FaWhatsappSquare color="#25D366" />} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} title={`${data.question}`} onShareWindowClose={() => saveQnaShare("whatsapp")} />
              <TwitterShareButton children={<FaTwitterSquare color="#1DA1F2" />} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} title={`${data.question}`} onShareWindowClose={() => saveQnaShare("twitter")}/>
              <MdContentCopy color="#1DA1F2" onClick={copyLinkToClipboard} />
            </div>
          </Popover>
      </div>
      <IconButton onClick={(e) => reduxState.info.info.feed?.find(feed => feed.id === data._id)?.id ? e.preventDefault() : saveMyFeed()}>
          <Bookmark htmlColor={reduxState.info.info.feed?.find(feed => feed.id === data._id)?.id ? "#B0343C":""} />
      </IconButton>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <div className="flex flex-col mb-4">
            <div className="flex flex-row items-center justify-between w-full">
            <Avatar alt="profile icon" src={(reduxState.authUser.isAuthenticated && reduxState.info.info.avatar)?reduxState.info.info.avatar:""} className="avatar cursor-default" />
                <input ref={answerInputRef} onChange={(e) => setAnswer(e.target.value)} className="rounded-lg mx-4 border-2 border-gray-200 bg-gray-200 w-full p-2 text-gray-800" placeholder="Write your answer here..." />
                <div style={{cursor:'pointer',background:'#B0343C'}} onClick={addAnswer} className="flex flex-row items-center rounded-lg p-2 text-lg font-bold text-gray-600 gap-2">
                <HiOutlineUpload color="#fff" />
                </div>
            </div>
        </div>
        <p>{data.answers.length} Answers</p>
        <Divider />
          {
            data.answers.length?data.answers?.map((cmnt)=>(
              <AnswerCard data={cmnt} key={cmnt} />
            )):<p className="w-full text-center text-lg font-bold text-gray-300 my-4">No Answers</p>
          }
        </CardContent>
      </Collapse>
    </div>
  );
}))

export default QuesCard;

const getTimePassed = (answerDate) => {
  let timeInMs = (new Date()).getTime() - (new Date(answerDate)).getTime();
  if(timeInMs < 10000){
    return `Just now`;
  }
  if(timeInMs < 60000){
    return `${Math.floor(Number(timeInMs/1000)) < 0?0:Math.floor(Number(timeInMs/1000))} sec ago`;
  }
  if(timeInMs < 3600000)
    return `${Math.floor(Number(timeInMs/60000))} min ago`;
  if(timeInMs < 2*3600000)
    return `${Math.floor(Number(timeInMs/3600000))} hour ago`;
  if(timeInMs < 86400000)
    return `${Math.floor(Number(timeInMs/3600000))} hours ago`
  if(timeInMs < 2*86400000)
    return `${Math.floor(Number(timeInMs/86400000))} day ago`
  if(timeInMs < 2592000000)
    return `${Math.floor(Number(timeInMs/86400000))} days ago`
  if(timeInMs < 2*2592000000)
    return `${Math.floor(Number(timeInMs/2592000000))} month ago`
  if(timeInMs < 31104000000)
    return `${Math.floor(Number(timeInMs/2592000000))} months ago`
  else
    return `${Math.floor(Number(timeInMs/31104000000))} year ago`
}

function AnswerCard({data}){
  const ansRef = useRef(null);

  useEffect(() => {
    ansRef.current.innerHTML = data.content;
  },[])
  return(
    <div className="flex flex-col gap-2 my-2">
      <div className="flex flex-row items-center gap-4">
        <Avatar  alt={data.user} src={data.avatar?data.avatar:''} />
        <div className="flex flex-col ">
        <p className="text-lg">{data.name}</p>
        <p className="text-xs text-gray-600">{getTimePassed(data.date)}</p>
      </div>
      </div>
      <p className="text-base mb-4" ref={ansRef} style={{whiteSpace:'pre-wrap',display:'flex',flexFlow:'row wrap'}}>
      </p>
      <Divider />
    </div>
  )
}

export {AnswerCard};
